var _g, _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSubcard1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 134,
    height: 46,
    viewBox: "0 0 134 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_1_16366)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 123.191,
    cy: 20,
    rx: 5.80879,
    ry: 5,
    fill: "#09B81D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.191 15.5C126.196 15.5 128.5 17.5824 128.5 20C128.5 22.4176 126.196 24.5 123.191 24.5C120.186 24.4999 117.882 22.4175 117.882 20C117.882 17.5825 120.186 15.5001 123.191 15.5Z",
    stroke: "#09B81D"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 45L8.75797 26.5L18.6329 37L24.4417 19.5L34.8975 37L50.5813 3L65.6842 26.5L82.5296 19.5L95.8899 31L107.507 6.5L116.221 19.5H124.353",
    stroke: "#09B81D",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_1_16366",
    x: 112.382,
    y: 10,
    width: 21.6177,
    height: 20,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5,
    result: "effect1_foregroundBlur_1_16366"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSubcard1);
export default __webpack_public_path__ + "static/media/subcard1.84c0778e279ba90f75b7afc5d6b36408.svg";
export { ForwardRef as ReactComponent };